var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEn = function SvgEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M-7 19.6V0h32.667v19.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-7 19.6 25.667 0zm32.667 0L-7 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 3.92,
    d: "M-7 19.6 25.667 0m0 19.6L-7 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "en_svg__c",
    width: 33,
    height: 20,
    x: -7,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.333 9.8h16.334V0zm0 0V0H-7zm0 0H-7v9.8zm0 0v9.8h16.334z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#en_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-7 19.6 25.667 0zm32.667 0L-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8102E",
    strokeWidth: 2.613,
    d: "M-7 19.6 25.667 0m0 19.6L-7 0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    stroke: "#fff",
    strokeWidth: 1.307,
    d: "M-7.652 12.413H6.72v7.84h5.227v-7.84H26.32V7.187H11.948v-7.84H6.72v7.84H-7.652z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "en_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#fff",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-7 19.6h32.667V0H-7z"
  })))));
};
export default SvgEn;